import * as Page from '../../components/content/page-header';
import { MainContent } from '../../components/layout/content';
import React, { useEffect, useState } from 'react';
import { PageHeader } from '../../components/layout/page-header';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { useParams } from 'react-router-dom';
import { axiosInstance } from '../../api/api';

export type AdTypeProps = {
  type: 'hero' | 'espn-hero' | 'mobile-hero' | 'sidekick' | 'portrait' | 'billboard' | 'expanded';
};

export const ViewChannel = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);
  const [slots, setSlots] = useState({});
  const { channelId } = useParams();

  async function fetchChannel(id: string): Promise<void> {
    try {
      const response = await axiosInstance().get(`/channels/${id}`);
      setSlots(response.data);
      setIsLoading(true);
    } catch (error) {
      console.error(error);
      setIsLoading(true);
    }
  }

  useEffect(() => {
    void fetchChannel(channelId as string);
  }, [channelId]);

  const adc = (container: string, type: string, slots: any[]): any => ({
    container,
    props: {
      type: type,
      channel: slots,
    },
  });
  const adcSideKick = (container: string, type: string, slots: any[]): any => ({
    container,
    props: {
      type: type,
      slots: slots,
    },
  });

  const AdType = (props: AdTypeProps): JSX.Element => {
    return (
      <div className="ad-unit-container">
        <div className="ad-unit-container-header">
          <Logo />
          {props.type === 'hero' && <span> - Hero</span>}
          {props.type === 'espn-hero' && <span> - ESPN Hero</span>}
          <div id="adc2"></div>
          {props.type === 'mobile-hero' && <span> - Mobile Hero</span>}
          <div id="adc3"></div>
          {props.type === 'sidekick' && <span> - Sidekick</span>}
          <div id="adc4"></div>
          {props.type === 'portrait' && <span> - Portrait</span>}
          <div id="adc5"></div>
          {props.type === 'billboard' && <span> - Billboard</span>}
          <div id="adc6"></div>
          {props.type === 'expanded' && <span> - Expanded</span>}
          <div id="adc7"></div>
        </div>
        <div className="ad-unit-container-body">
          <div id={`adc-${props.type}`}></div>
          {props.type === 'sidekick' && isLoading && (
            <>
              {/* @ts-ignore */}
              {ADC.init(adcSideKick(`adc-${props.type}`, props.type, slots), 2000)}
            </>
          )}
          {props.type !== 'sidekick' && isLoading && (
            <>
              {/* @ts-ignore */}
              {ADC.init(adc(`adc-${props.type}`, props.type, slots), 2000)}
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Page.Header>
        <PageHeader
          title="Manage Channel"
          buttons={[
            { title: 'Edit Channel', type: 'link', location: `/channels/${channelId!}/edit` },
            {
              title: 'Adunit Preview',
              type: 'secondary',
              location: `/channels/${channelId!}/preview`,
            },
            { title: 'Blast', type: 'primary', location: `/channels/${channelId!}/blast` },
          ]}
        />
      </Page.Header>
      <MainContent className="view-channel">
        <AdType type="hero" />
        <AdType type="espn-hero" />
        <AdType type="mobile-hero" />
        <AdType type="sidekick" />
        <AdType type="portrait" />
        <AdType type="billboard" />
        <AdType type="expanded" />
      </MainContent>
    </>
  );
};
